import React from 'react';
// import Select from 'react-select';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import FormHelper from '../form.js';
// import PresenterCountry from '../../../country/presenter.js';
// import RequestPropertiesCountry from '../../../country/helper/request.props.js';
import {ButtonValidation, ButtonCancel} from '../../../../component/Button.js'
import SelectQuery from '../../../../component/SelectQuery.js';

export default class ModalProvince extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pk            : props.data.pk,
      name          : props.data.name,
      abbreviations : props.data.abbreviations,
      country       : props.data.country,
    }

    this.modalAction = this.modalAction.bind(this)
    this.handleCountryChange = this.handleCountryChange.bind(this)
  }

  modalAction() {
    const {mode, register, update} = this.props

    if(!FormHelper.ValidateForm(this.state)) {
      return
    }

    if(mode === "modal_add") {
      let data = {
        name          : this.state.name,
        abbreviations : this.state.abbreviations,
        country       : typeof this.state.country === "object" ? this.state.country.pk : this.state.country,
      }
      register(data);
    } else {
      let data = {
        pk            : this.state.pk,
        name          : this.state.name,
        abbreviations : this.state.abbreviations,
        country       : typeof this.state.country === "object" ? this.state.country.pk : this.state.country,
      }
      update(data)
    }
  }

  handleCountryChange(event) {
    this.setState({
      country: event.value,
    })
  }

  componentDidUpdate(prevProps) {
    let new_state = {}
    if(this.props.isModal !== prevProps.isModal) {
      if(this.props.mode === "modal_update") {
        new_state = {
          pk            : this.props.data.pk,
          name          : this.props.data.name,
          abbreviations : this.props.data.abbreviations,
          country       : typeof this.props.data.country === "object" ? this.props.data.country.pk : this.props.data.country,
        }
      } else {
        new_state = {
          pk            : "",
          name          : "",
          abbreviations : "",
          country       : ""
        }
      }
      this.setState(new_state)
    }
  }

  render() {
    const {isModal, close, mode, is_process} = this.props
    return (
      <Modal isOpen={isModal} toggle={close}>
        <ModalHeader toggle={close}>{mode === "modal_add" ? 'Add new' : 'Update'} province</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="required">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Type Name"
                autoComplete="nope"
                value={this.state.name}
                onChange={(e) => this.setState({name: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Abbreviations</label>
              <input
                type="text"
                className="form-control"
                placeholder="Type Abbreviations"
                autoComplete="nope"
                value={this.state.abbreviations}
                maxLength={9}
                onChange={(e) => this.setState({abbreviations: e.target.value})}
              />
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Country</label>
              <SelectQuery
                placeholder="Enter Country"
                value={this.state.country}
                onChange={this.handleCountryChange}
                urlKey="read-country-autocomplete"
                valKey="pk"
                valLabel="Name"
                initOption={this.props.data.country}
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonCancel onClick={close}>cancel</ButtonCancel>
          <ButtonValidation is_process={is_process} onClick={this.modalAction}>
            {mode === "modal_add" ? "Save" : "Update"}
          </ButtonValidation>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/superuser/province/helper/component/Modal.js